module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/people_c-105c4e24496736898a6a6531ebb7266e.svg";